import { useSelection } from "@frend-digital/centra/client";
import { EventSubscription } from "@frend-digital/events/client";
import { BeforeEvent, centraGTMAdapter } from "@frend-digital/events/gtm";
import { useMemo } from "react";

const Events = () => {
  const { data: selection } = useSelection();

  const adapters = useMemo(() => {
    const beforeGtmEvent: BeforeEvent = async e => e;
    return [
      centraGTMAdapter({ beforeEvent: beforeGtmEvent, selection: selection }),
    ];
  }, [selection]);

  return <EventSubscription adapters={adapters} />;
};

export default Events;
